<div
  class="row-container"
  [ngbPopover]="tooltipTemplate"
  [openDelay]="300"
  [closeDelay]="300"
  triggers="mouseenter:mouseleave"
  container="body"
  popoverClass="rask-icon-popover"
  >
  @if (input.type === 'Kundorder') {
    <i class="fal fa-sm fa-industry icon icon-fix" aria-hidden="true"></i>
  }
  @if (input.type === 'Leverantorsorder') {
    <i class="fal fa-sm fa-clipboard-list icon icon-fix" aria-hidden="true"></i>
  }
  @if (input.type === 'Terminalorder') {
    <i class="fal fa-sm fa-warehouse-alt icon icon-fix" aria-hidden="true"></i>
  }
  <span>
    @if (input.title !== null) {
      <span class="w90">{{input.naturalKey}} - {{input.title}}</span>
    }
    @if (input.title === null) {
      <span class="w90">{{input.naturalKey}} - {{input.type}}</span>
    }
  </span>
  @if (input.type !== 'Leverantorsorder') {
    <span>
      <br />
      <span class="float-start left-margin w45">{{input.metadata["mottagningsplats"]}}</span>
      <span class="float-end w45 text-end">{{input.metadata["handelssortiment"]}}</span>
      <br />
      <span class="float-start left-margin w45">{{input.metadata["periodFrom"] | date:'yyyy-MM-dd'}}</span>
      <span class="float-end w45 text-end">{{input.metadata["periodTom"] | date:'yyyy-MM-dd'}}</span>
    </span>
  }
</div>
